module.exports = __webpack_public_path__ + "img/bxs-phone.86d81a23.svg";